import strFunc from "@/lib/lyg/string";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import TodoContentRow from "./row";

function TodoContent(props: any) {
  let myProps = {
    todo_data_arr: [],
    set_todo_data_arr: (inData: any) => { },
    default_todo_data: {},
    Style: {},
    ...props
  };
  let Style = myProps.Style;
  let todo_data_arr = myProps.todo_data_arr;
  let default_todo_data = myProps.default_todo_data;

  const add_todo_content_row = () => {
    let tmp_todo_data_arr = [...todo_data_arr];
    let new_todo_data={...default_todo_data};
    if(tmp_todo_data_arr.length>0){
      let last_row=tmp_todo_data_arr[tmp_todo_data_arr.length-1];
      new_todo_data={...last_row};
    }
    tmp_todo_data_arr.push(new_todo_data);
    myProps.set_todo_data_arr(tmp_todo_data_arr);
  };

  const delete_todo_content_row = (row_num: number) => {
    let tmp_todo_data_arr = [];
    for (let i = 0; i < todo_data_arr.length; i++) {
      if (i != row_num) {
        tmp_todo_data_arr.push(todo_data_arr[i]);
      }
    }
    myProps.set_todo_data_arr(tmp_todo_data_arr);
  };

  const get_todo_content_row_tags = () => {
    let row_tags = todo_data_arr.map((item: any, idx: number) => {
      return (
        <TodoContentRow
          key={idx}
          row_num={idx}
          todo_data={item}
          todo_data_arr={todo_data_arr}
          set_todo_data_arr={myProps.set_todo_data_arr}
          delete_todo_content_row={delete_todo_content_row}
        ></TodoContentRow>
      );
    });
    return row_tags;
  };

  return (
    <div>
      <div className={Style.sub_title}>
        내용 
        <button className="btn btn-dark ml-1"
          onClick={() => {
            add_todo_content_row();
          }}
        >+</button>
      </div>
      <div className="write_table_small">
        <table>
          <colgroup>
            <col width={"100px"}></col>
            <col width={"40%"}></col>
            <col width={"100px"}></col>
            <col width={"40%"}></col>
          </colgroup>
          <tbody>
            {get_todo_content_row_tags()}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default TodoContent;